<template>
  <div v-if="currentDealership" class="dealerships -new">
    <h1 class="page-title">
      <router-link to="/dealerships">Dealerships</router-link>
      <span class="divider">&rsaquo;</span>
      {{ currentDealership.name }}
    </h1>

    <dealership-form
      v-if="currentDealership"
      :dealership="currentDealership"
      :form-state="formState"
      :errors="errors"
      :button-text="'Update Dealership'"
      @changeMade="changeMade"
      @submit="update"
      @revertState="formState = 'normal'"
    ></dealership-form>
  </div>
</template>

<script>
import { mapState } from "vuex";

import dealershipForm from "@/components/dealershipForm/main";
import auth from "@/helpers/auth";

export default {
  components: { dealershipForm },
  beforeRouteEnter(to, from, next) {
    if (!auth.signedIn()) return next("/sign-in");
    next();
  },

  beforeRouteLeave(to, from, next) {
    this.ensureFormSaved(next);
  },

  beforeRouteUpdate(to, from, next) {
    this.ensureFormSaved(next);
  },

  data() {
    return {
      formState: "normal",
      errors: {},
      changesMade: false
    };
  },

  computed: {
    ...mapState({
      dealerships: (state) => state.dealerships.all,
      currentDealership: (state) => state.dealerships.current
    })
  },

  watch: {
    dealerships() {
      this.setCurrentDealership();
    },

    $route(to, from) {
      this.setCurrentDealership();
    },

    currentDealership() {
      this.$nextTick(() => {
        this.changesMade = false;
      });
    }
  },

  created() {
    if (this.dealerships.length) this.setCurrentDealership();
  },

  methods: {
    setCurrentDealership() {
      this.$store.dispatch("changeCurrentDealership", this.$route.params.id);
    },

    update(params) {
      this.formState = "loading";

      this.$store
        .dispatch("updateDealership", params)
        .then((resp) => {
          this.formState = "done";
          this.errors = {};
          this.changesMade = false;
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
          this.formState = "normal";
        });
    },

    ensureFormSaved(next) {
      if (!this.changesMade || confirm("Unsaved changes will be lost, are you sure you want to leave?")) next();
    },

    changeMade() {
      this.changesMade = true;
    }
  }
};
</script>
